export default "__VITE_ASSET__O4hzcojY__"